import React from 'react'
import Accordion from 'react-bootstrap/Accordion'
import AccordionHeader from 'react-bootstrap/AccordionHeader'
import styles from '../../css/generals/UnlicensedMessage.module.css'
import { useTranslation } from 'react-i18next'

export default function UnlicensedMessage () {
  const { t } = useTranslation('dashboardDevice')

  return (
        <Accordion className={styles.containerAccordion}>
            <Accordion.Item eventKey="0" className={styles.accordion_item}>
                <AccordionHeader bsPrefix={styles.accordion_header} /* className={styles.accordionHeader} */>
                    <i className={`pi pi-exclamation-circle ${styles.iconUnlicensed}`} />
                    {t('message20')}
                    </AccordionHeader>
                <Accordion.Body className={styles.accordionBody}>
                  {t('message21')}
                </Accordion.Body>
            </Accordion.Item>
    </Accordion>
  )
}
